// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__38rAv","inner":"Footer_inner__35-d4","nextIcon":"Footer_nextIcon__3SWNf","innerLeft":"Footer_innerLeft__3OIuQ"};